module.exports = __webpack_public_path__ + "static/media/0025_LES_ENSEIGNES_LE_POISSONNIER_SCRABBLE.81e66a55.png";